import { startOfDay, fromUnixTime, subDays, endOfDay, getUnixTime } from 'date-fns';
import { DateRangePicker } from '@crazyegginc/hatch';

import { useFunnelEditorContext } from '../../funnel-editor-context';
import { useSelectedSite } from '/src/hooks';
import { humanizeDateRange } from '/src/features/web-analytics/utils';

export function DateRangeRow() {
  const { date, setDateRange } = useFunnelEditorContext();
  const { selectedSite } = useSelectedSite();

  const analyticsEnabledAt = selectedSite?.webAnalyticsEnabledAt
    ? startOfDay(fromUnixTime(selectedSite.webAnalyticsEnabledAt))
    : null;
  const thirtyDaysAgo = startOfDay(subDays(new Date(), 30));

  const lowerBoundary = analyticsEnabledAt
    ? analyticsEnabledAt < thirtyDaysAgo
      ? analyticsEnabledAt
      : thirtyDaysAgo
    : thirtyDaysAgo;

  return (
    <div className="mb-2.5 flex justify-between items-center">
      <div className="ml-1 text-header-3">
        {humanizeDateRange([getUnixTime(date.start_date), getUnixTime(date.end_date), date.special])}
      </div>
      <div className="mr-1">
        <DateRangePicker
          lowerBoundary={lowerBoundary}
          upperBoundary={endOfDay(new Date())}
          startDate={date?.start_date}
          endDate={date?.end_date}
          special={date?.special}
          setDateRange={setDateRange}
          setCommonDateRange={setDateRange}
          showCommonRanges={true}
          size="lg"
        />
      </div>
    </div>
  );
}
